<script>
    import Software from "../ComputerDashboard/Software.svelte"
    import SystemOverview from "./SystemOverview.svelte"
    import Services from "../ComputerDashboard/Services.svelte"
    import Tabs from "../../layout/Tabs.svelte"
    export let computerId;
    export let hostName;
    const software = "Software";
    const systemOverview = "System Overview";
    const services = "Services";

    let tabs = [systemOverview, software, services]
    let activeTab = systemOverview;
    const changeTab = (e) => {
    activeTab = e.detail;
  }    
    
</script>
<div class="d-flex">
    <h4 class="font-weight-bold text-primary mb-0">{hostName}</h4>
    <div class="ml-auto">
        <Tabs {tabs}{activeTab} on:tabChange={changeTab}></Tabs>
    </div>    
</div>
<div class="mt-4">
    {#if activeTab === software}
        <Software {computerId}></Software>
    {:else if activeTab == services}
        <Services {computerId}></Services>
    {:else if activeTab === systemOverview}
        <SystemOverview {computerId}></SystemOverview>
    {/if}
    
</div>
<style>
    
</style>